import client from "@irati/utils/services/apollo"

import {
  CompanyNewsTile,
  MutationCreateCompanyNewsRowArgs,
  MutationDeleteCompanyNewsRowArgs,
  LayoutWidgets,
  MutationUpdateCompanyNewsTileArgs,
  MutationUpdateHomePageLayoutArgs
} from "@irati/types"

import createCompanyNewsRowMutation from "./mutations/CreateCompanyNewsRow"
import deleteCompanyNewsRowMutation from "./mutations/DeleteCompanyNewsRow"
import updateCompanyNewsTileMutation from "./mutations/UpdateCompanyNewsTile"
import updateHomePageLayoutMutation from "./mutations/UpdateHomePageLayout"

const QUERIES_TO_REFETCH = ["TenantHomePage"]

class HomePage {
  createCompanyNewsRow(variables: MutationCreateCompanyNewsRowArgs): Promise<CompanyNewsTile[]> {
    return client.mutate({refetchQueries: QUERIES_TO_REFETCH, mutation: createCompanyNewsRowMutation, variables}).then(({data}) => data)
  }
  deleteCompanyNewsRow(variables: MutationDeleteCompanyNewsRowArgs): Promise<boolean> {
    return client
      .mutate({awaitRefetchQueries: true, refetchQueries: QUERIES_TO_REFETCH, mutation: deleteCompanyNewsRowMutation, variables})
      .then(({data}) => data)
  }
  updateCompanyNewsTile(variables: MutationUpdateCompanyNewsTileArgs): Promise<CompanyNewsTile[]> {
    return client.mutate({refetchQueries: QUERIES_TO_REFETCH, mutation: updateCompanyNewsTileMutation, variables}).then(({data}) => data)
  }
  updateHomePageLayout(variables: MutationUpdateHomePageLayoutArgs): Promise<LayoutWidgets> {
    return client.mutate({refetchQueries: QUERIES_TO_REFETCH, mutation: updateHomePageLayoutMutation, variables}).then(({data}) => data)
  }
}

const service = new HomePage()

export const createCompanyNewsRow = service.createCompanyNewsRow
export const deleteCompanyNewsRow = service.deleteCompanyNewsRow
export const updateCompanyNewsTile = service.updateCompanyNewsTile
export const updateHomePageLayout = service.updateHomePageLayout

export default service
